import { createIsomorphicFn, createServerFn } from '@tanstack/react-start'
import {
  deleteCookie,
  getCookie,
  setCookie
} from '@tanstack/react-start/server'
import z from 'zod'

export const getToken = createIsomorphicFn()
  .server(() => getCookie('__auth_token') ?? null)
  .client(() => localStorage.getItem('__auth_token'))

export const setToken = createServerFn({ method: 'POST' })
  .inputValidator(z.object({ token: z.string().min(1) }))
  .handler(({ data: { token } }) => {
    setCookie('__auth_token', token, {
      path: '/',
      httpOnly: true,
      secure: true,
      sameSite: 'lax',
      maxAge: 60 * 60 * 24 * 7
    })
    return { success: true }
  })

export const deleteToken = createServerFn({ method: 'POST' }).handler(() => {
  deleteCookie('__auth_token', { path: '/' })
  return { success: true }
})
